import Rules from "@/utils/Rules";

import HeaderCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/HeaderCheckList.vue"
import CardCheckList from "@/components/Projects/Diagnostic/Tabs/CheckList/CardCheckList.vue"
import HydrometerList from "@/components/Projects/Diagnostic/Tabs/CheckList/HydrometerList.vue"
import BombList from "@/components/Projects/Diagnostic/Tabs/CheckList/BombList.vue"
import ReservoirList from "@/components/Projects/Diagnostic/Tabs/CheckList/ReservoirList.vue"
import SolutionList from "@/components/Projects/Diagnostic/Tabs/CheckList/SolutionList.vue"
import InputFiles from "@/components/Forms/Input/input-files.vue";
import { mapGetters } from "vuex";

import { openDatabase } from '@/pages/Projects/Utils/IndexedDB.js';
import InputNumber from "@/components/Inputs/NumberInput.vue";

const newCheckList = () => {
    return {
        tipoProjeto: "",
        usersAmount: "",
        building_type: "",
        amount_units: "",
        amount_wcs: "",
        building_by_area: "",
        wcs_by_unit: "",
        showerGas: "",
        showerEletric: "",
        amount_area: "",
        solutionList: [],
        bombList: [],
        hydrometerList: [],
        reservoirList: [],
        file_before_solution: null,
        file_after_solution: null,
        path_before_solution: null,
        path_after_solution: null,
        optionsManagementPeriod: "monthly"
    }
}

export default {
    name: "CheckListTab",

    components: {
        HeaderCheckList,
        CardCheckList,
        HydrometerList,
        BombList,
        ReservoirList,
        SolutionList,
        InputFiles,
        InputNumber
    },

    props: {
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Object,
            default: () => ({})
        },
        desiredProposal: {
            type: Array,
            default: []
        },
        disabledFields:{
            type: Boolean,
            default: false,
        },
        enableAddEvent:{
            type: Boolean,
            default: false,
        },
        projectId: {
            type: String,
            default: null,
        },

    },

    data: () => ({
        db: null,
        is_loading: false,
        isValidForm: false,
        diagnostic: {},
        options: [
            { text: "Apto Individual", value: "single_apartment" },
            { text: "Casa", value: "home" },
            { text: "Cond. Residencial", value: "residential_condominium" },
            { text: "Cond. Empresarial", value: "business_condominium" },
            { text: "Cond. Misto", value: "mixed_condominium" },
            { text: "Comercial", value: "commercial" },
            { text: "Industrial", value: "industry" },
            { text: "Orgão Público", value: "public_agency" },
        ],
        checkList: newCheckList(),
        deletedItemsWithPhoto: [],
    }),

    computed: {
        ...mapGetters([
                    "getFranqueados",
                    "getCurrentUser",
                    "getCurrentUserRank",
                    "getStatusCanDeletedDataAdmin",
                ]),
        isManagementProposal(){
            return this.desiredProposal.includes("management")
        },
        isFranchisee() {
            return this.getCurrentUserRank === "Franqueado"
        },
        rulesRequired() {
            return Rules.required();
        },
        rulesCEP() {
            return Rules.cep();
        },
        rulesLogradouro() {
            return Rules.string(false, null, 128);
        },
        rulesCity() {
            return Rules.string(false, null, 64);
        },
        rulesDistrict() {
            return Rules.string(false, null, 64);
        },
        rulesAdditionalAddress() {
            return Rules.string(false, null, 64);
        },
        rulesHouseNumber() {
            return Rules.string(false, null, 16);
        },
    },

    methods: {
        calculateTotalWc() {
            this.checkList.amount_wcs = this.checkList.wcs_by_unit * this.checkList.amount_units
        },
        calculateTotalUnits() {
            this.checkList.amount_units = this.checkList.building_type * this.checkList.building_by_area * this.checkList.amount_area;
            this.calculateTotalWc();
        },
        emitDiagnostic() {
            // this.$emit('param:update', this.checkList)
        },
        emitValidate(status) {
            this.$emit('validate', status)
        },
        getGroupProjectType() {
            if (['single_apartment', 'home'].includes(this.checkList.tipoProjeto)) {
                return '1'
            } else {
                //  Cond. Residencial / Cond. Empresarial / Cond. Misto / Comercial / Indústria / Orgão Público
                return '2'
            }
        },
        showHydrometerList() {
            return true
        },
        showBombList() {
            return true
        },
        showReservoirList() {
            return true
        },
        addHydrometer(hydrometer, index) {
            if (index < 0) {
                this.checkList.hydrometerList.push(hydrometer)
            } else {
                this.checkList.hydrometerList[index] = hydrometer
                this.addEvent({ ...this.checkList, id_project: this.projectId })
            }
        },
        removeHydrometer(index) {
            if(this.checkList.hydrometerList[index].path_photo) this.deletedItemsWithPhoto.push(this.checkList.hydrometerList[index].path_photo)
            if(this.checkList.hydrometerList[index].path_photo2) this.deletedItemsWithPhoto.push(this.checkList.hydrometerList[index].path_photo2)
            this.checkList.hydrometerList = this.checkList.hydrometerList.filter((hydrometerItem, itemIndex) => itemIndex !== index)
        },
        addBomb(bomb, index) {
            if (index < 0) {
                this.checkList.bombList.push(bomb)
            } else {
                this.checkList.bombList[index] = bomb
                this.addEvent({ ...this.checkList, id_project: this.projectId })
            }
        },
        removeBomb(index) {
            if(this.checkList.bombList[index].path_photo) this.deletedItemsWithPhoto.push(this.checkList.bombList[index].path_photo)
            if(this.checkList.bombList[index].path_photo2) this.deletedItemsWithPhoto.push(this.checkList.bombList[index].path_photo2)
            this.checkList.bombList = this.checkList.bombList.filter((bombItem, itemIndex) => itemIndex !== index)
        },
        addReservoir(reservoir, index) {
            if (index < 0) {
                this.checkList.reservoirList.push(reservoir)
            } else {
                this.checkList.reservoirList[index] = reservoir
                this.addEvent({ ...this.checkList, id_project: this.projectId })
            }
        },
        removeReservoir(index) {
            if(this.checkList.reservoirList[index].path_photo) this.deletedItemsWithPhoto.push(this.checkList.reservoirList[index].path_photo)
            if(this.checkList.reservoirList[index].path_photo2) this.deletedItemsWithPhoto.push(this.checkList.reservoirList[index].path_photo2)
            this.checkList.reservoirList = this.checkList.reservoirList.filter((reservoirItem, itemIndex) => itemIndex !== index)
        },
        addSolution(solution, index) {
            if (index < 0) {
                this.checkList.solutionList.unshift(solution)
            } else {
                Object.keys(solution).forEach(
                    (key) => {
                        this.$set(this.checkList.solutionList[index], key, solution[key])
                    }
                )
            }
        },
        removeSolution(item) {
            if(item.path_after_solution) this.deletedItemsWithPhoto.push(item.path_after_solution)
            if(item.path_before_solution) this.deletedItemsWithPhoto.push(item.path_before_solution)
            this.$set(item, 'isDeleted', true)
        },
        async addEvent(data) {
            if(this.enableAddEvent){
                const transaction = this.db.transaction(["diagnostics"], "readwrite");
                const diagnosticsIndexed = transaction.objectStore("diagnostics");
                await diagnosticsIndexed.put({...data, lastUpdateAt: new Date().getTime()});
            }
        },

    },
    async created() {
        this.db = await openDatabase();
    },
    watch: {
        param: {
            immediate: true,
            handler: function (newValue) {
                if (newValue) this.checkList = { ...this.checkList, ...newValue }
            }
        },
        'checkList.tipoProjeto': function (newValue) {
            if (['single_apartment', 'home'].includes(newValue)) {
                this.checkList.building_type = ""
                this.checkList.amount_area = ""
                this.checkList.building_by_area = ""
                this.checkList.wcs_by_unit = ""
                this.checkList.amount_units = ""
            } else {
                this.checkList.usersAmount = ""
                this.checkList.showerEletric = ""
                this.checkList.showerGas = ""
            }
        },
        checkList: {
            deep: true,
            handler: function (newValue) {
                this.addEvent({ ...newValue, id_project: this.projectId })
            }
        },

    },

};
